/* eslint-disable prefer-destructuring */
/* eslint-disable */
import React from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './constants/authSsoConfig';
// import './index.scss';
import App from './App';
import { AuthProvider } from './hooks/useAuth';

const msalInstance = new PublicClientApplication(msalConfig);

// const navigate = useNavigate();

// get initialize msalInstance
msalInstance.initialize().then(() => {
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event?.payload) {
      const authenticationResult = event.payload as AuthenticationResult;
      const account = authenticationResult.account;
      msalInstance.setActiveAccount(account);
    }
  });

  msalInstance.handleRedirectPromise().then((response) => {
    if (response && response.account) {
      const account = msalInstance.getActiveAccount();

      // if (!account) {
      // msalInstance.initialize();
      // }
      // User is authenticated, you can proceed to  app
      // navigate('/home', { replace: true });
    }
  }).catch((err: any) => {
    console.log(err);
  });
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
  
root.render(
  
    <BrowserRouter basename={window.location.pathname.startsWith('/ui') ? '/ui' : '/'}>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MsalProvider>
    </BrowserRouter>
  
);
